import { atom } from "recoil";

const pointsBufferState = atom({
  key: "pointsBufferState",
  default: 0,
});

export default pointsBufferState;
